/**
 * Best-effort surface text for the structured `{ error: { code, message } }`
 * envelope returned by the Worker, falling through to plain `Error`
 * messages and the literal value when shape is unknown.
 */
export function extractErrorMessage(error: unknown): string {
  if (!error) return 'Unknown error';
  if (typeof error === 'object' && error !== null) {
    const e = error as { error?: { code?: string; message?: string }; message?: string };
    if (e.error?.message) return e.error.message;
    if (e.error?.code) return e.error.code;
    if (e.message) return e.message;
  }
  return String(error);
}
